export default "__VITE_ASSET__337e5dc3__"